import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Button, Form } from "react-bootstrap";
import axios from "axios";
import { useUser } from "./UserContext";
import apiClient from "./apiClient";
import { ToastContainer, toast } from "react-toastify";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  background-color: #f5f5f5;
`;

const LoginForm = styled(Form)`
  width: 500px;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const LoginButton = styled(Button)`
  width: 100%;
`;

const SpacedFormGroup = styled(Form.Group)`
  margin-bottom: 15px;
`;

const SecretQuestionForm = styled(Form.Control)`
  color: black; /* 文字色を黒に設定 */
`;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function ForgotPassword() {
  const [userID, setUserID] = useState("");
  const [recoveryCode, setRecoveryCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (newPassword === confirmNewPassword) {
        const response = await apiClient.post(`${API_BASE_URL}/api/accounts/recovery-codes/reset-password/`, {
          username: userID.trim(),
          code: recoveryCode.trim(),
          new_password: newPassword,
        });

        const newRecoveryCode = response?.data?.recovery_code ?? "";

        navigate("/ForgotPasswordComplete", {
          state: { recoveryCode: newRecoveryCode },
        });
      } else {
        toast.error("パスワードと確認用パスワードが不一致です");
      }
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 400) {
        toast.info("入力内容に誤りがあります。");
      } else if (errorCode === 500) {
        toast.error("サーバエラーが発生しました。しばらくしてから再度お試しください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
    }
  };

  const handleUserIDChange = (event) => {
    setUserID(event.target.value);
  };

  return (
    <React.StrictMode>
      <Container>
        {/* <h4>パスワードを忘れた方</h4> */}
        <LoginForm onSubmit={handleSubmit}>
          <SpacedFormGroup controlId="formUserID">
            <Form.Label>ユーザーID</Form.Label>
            <Form.Control type="userID" placeholder="ユーザーID" value={userID} onChange={handleUserIDChange} />
          </SpacedFormGroup>
          <SpacedFormGroup controlId="recoveryCode">
            <Form.Label>リカバリーコード</Form.Label>
            <Form.Control type="recoveryCode" placeholder="リカバリーコード" value={recoveryCode} onChange={(e) => setRecoveryCode(e.target.value)} />
          </SpacedFormGroup>
          <SpacedFormGroup controlId="formBasicPassword">
            <Form.Label>新しいパスワード</Form.Label>
            <Form.Control type="password" value={newPassword} placeholder="新しいパスワード" onChange={(e) => setNewPassword(e.target.value)} />
          </SpacedFormGroup>
          <SpacedFormGroup controlId="formBasicPassword">
            <Form.Label>新しいパスワード（確認）</Form.Label>
            <Form.Control type="password" value={confirmNewPassword} placeholder="新しいパスワード（確認）" onChange={(e) => setConfirmNewPassword(e.target.value)} />
          </SpacedFormGroup>

          <Button variant="primary" type="submit" size="lg" className="w-100 text-center d-flex align-items-center justify-content-center" style={{ minWidth: "120px", whiteSpace: "nowrap", fontSize: "1.2rem", backgroundColor: "#282c34", color: "#ffffff", borderColor: "#282c34" }}>
            パスワード変更
          </Button>
        </LoginForm>
        <ToastContainer position="top-center" autoClose={3000} />
      </Container>
    </React.StrictMode>
  );
}

export default ForgotPassword;
